import React from 'react';

import { CMSComponentProps } from '@/components/cms/CMSComponent';

import { BlockWrapperProps } from '@/features/utils/BlockWrapper';

// TODO add typechecking of components names in the components files itself
const ignoreList = [
  'molecules.breadcrumbs',
  'carousels.top-banner',
  'shared.cta-block',
  'shared.text-block',
  'carousels.hero-carousel',
  'carousels.images-carousel',
];

export function SectionColoring({
  children,
  invert = false,
}: {
  children: React.ReactNode;
  invert?: boolean;
}) {
  let sectionColoringBackgroundColor = invert ? 'neutral-N00' : 'neutral-N02';

  return (
    <>
      {React.Children.map(children, (child) => {
        if (
          React.isValidElement(child) &&
          !ignoreList.includes(
            (child.props as CMSComponentProps)?.block?.__component
          )
        ) {
          if (sectionColoringBackgroundColor === 'neutral-N00') {
            sectionColoringBackgroundColor = 'neutral-N02';
          } else {
            sectionColoringBackgroundColor = 'neutral-N00';
          }

          return React.cloneElement(child, {
            backgroundColor:
              (child.props as CMSComponentProps)?.backgroundColor ??
              sectionColoringBackgroundColor,
          } as Partial<BlockWrapperProps>);
        }
        return child;
      })}
    </>
  );
}
